import { createContext, Dispatch, SetStateAction } from "react";

/*
If isSubscribed is null it means the user hasn't been asked to subscribe to push notifications yet.
*/

interface PushNotificationsContextType {
  isSubscribed: boolean | null;
  setIsSubscribed: Dispatch<SetStateAction<boolean | null>>;
}

const PushNotificationsContext = createContext<PushNotificationsContextType>({
  isSubscribed: false,
  setIsSubscribed: () => {},
});

export default PushNotificationsContext;

